import { h } from 'preact';

export default props => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" {...props}>
		<path d="M4.15527 0.000854492C3.60299 0.000854492 3.15527 0.44857 3.15527 1.00085V23.0009C3.15527 23.5531 3.60299 24.0009 4.15527 24.0009H8.15527C8.70756 24.0009 9.15527 23.5531 9.15527 23.0009V1.00085C9.15527 0.44857 8.70756 0.000854492 8.15527 0.000854492H4.15527ZM16.1553 0.000854492C15.603 0.000854492 15.1553 0.44857 15.1553 1.00085V23.0009C15.1553 23.5531 15.603 24.0009 16.1553 24.0009H20.1553C20.7076 24.0009 21.1553 23.5531 21.1553 23.0009V1.00085C21.1553 0.44857 20.7076 0.000854492 20.1553 0.000854492H16.1553Z" />
	</svg>
);

